import React, { ComponentType, useCallback } from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

import { ROUTE_HOME } from '../../../../constants/routes';
import NavPrimaryMenuButton from '../NavPrimaryMenuButton';

const NavHomeButton: ComponentType<InjectedIntlProps> = props => {
  const { intl } = props;
  const history = useHistory();
  const location = useLocation();
  const handleOnClick = useCallback(() => history.push(ROUTE_HOME), [history]);

  return (
    <NavPrimaryMenuButton handleOnClick={handleOnClick} isHighlighted={location.pathname === ROUTE_HOME}>
      {intl.formatMessage(messages.homeButton)}
    </NavPrimaryMenuButton>
  );
};

export default injectIntl(NavHomeButton);

const messages = defineMessages({
  homeButton: {
    defaultMessage: 'Home',
    description: 'Button on navigation bar which takes you to home page when clicked',
    id: 'uchi.nav.homeButton',
  },
});
